import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Starfield from "@/components/Starfield";

const TITLES = {
  "/": "AstroFriend — AI हस्तरेखा | AI Palm Reading in Hindi & English",
  "/instructions": "हथेली की फोटो कैसे लें | How it works — AstroFriend",
  "/pricing": "मूल्य | Pricing — AstroFriend",
  "/refund-policy": "Refund Policy — AstroFriend",
  "/admin": "Admin — AstroFriend",
  "/login": "Login — AstroFriend",
  "/upload": "हथेली अपलोड करें | Upload palm — AstroFriend",
  "/profile": "मेरी रीडिंग | My readings — AstroFriend",
};

export default function Layout({ children }) {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname.startsWith("/library")) return;
    document.title = TITLES[pathname] || (pathname.startsWith("/result") ? "आपकी हस्तरेखा रीडिंग | Your palm reading — AstroFriend" : "AstroFriend");
  }, [pathname]);
  return (
    <div className="app-bg">
      <Starfield />
      <Header />
      <main className="relative z-10">{children}</main>
      <Footer />
    </div>
  );
}
